let indexToUse;

function findIndexToUse(data) {
    if (indexToUse === undefined) {
        if (data.quotes.length > 0) {
            // Ensure min and max are integers for consistent behavior
            let min = Math.ceil(0);
            let max = Math.floor(data.quotes.length-1);
            // Generate a random number between min (inclusive) and max (inclusive)
            indexToUse = Math.floor(Math.random() * (max - min + 1)) + min;
        } else {
            indexToUse = 0;
        }
    }
    // window.console.log('indexToUse: '.concat(indexToUse));
    return indexToUse;
}


function Quote({ data }) {

    // set our index to use on page load
    findIndexToUse(data);

    return (
        <div key={data.documentId} className="quote row tp-div background-full-width vibrant-gradient parallax" id="quoteBand">
            {/*FIXME: an array of quotes are coming through instead of a single one??*/}
            <div className="container quote" style={{maxWidth: '1320px',  textAlign: data.quotes[0].alignment}}>
                <p>
                    <span style={{color:'#FFFFFF'}}>
                        <span style={{fontSize:'24px'}}>
                            {data.quotes[indexToUse].text}
                        </span>
                    </span>
                </p>
                <p>
                    <span style={{color:'#FFFFFF'}}>
                        {data.quotes[indexToUse].author}
                    </span>
                </p>
            </div>
        </div>
    );
}

export default Quote;
